import React, { useState } from 'react';
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome';
import CommentForm from './CommentForm';

export default function Replies({ data, id }) {
    const [reply, setReply] = useState(null);
    const { nodes: replies } = data;

    replies.sort((a, b) => a.databaseId - b.databaseId);

    const toggleReply = parent => {
      if (reply === parent) {
        setReply();
      } else {
        setReply(parent);
      }                 
    }

    return (
        <ol className="comment-list">                         
            {
                replies.map(r => (
                    <li key={r.databaseId}>
                        <article>
                            <header className="comment-meta">                         
                                <h4>
                                  <img width={64} src={`/api/static/avatar/${r.author.node.gravatarId}.png`} alt="avatar" />
                                  <span style={{flex: 1}} dangerouslySetInnerHTML={{ __html: r.author.node.name }} />
                                </h4>            
                                <span>
                                  <time dateTime={r.date}>
                                    {r.date}
                                  </time> 
                                </span> 
                            </header> 
                            <section>
                              <div dangerouslySetInnerHTML={{ __html: r.content }}/>
                              { r.replies ? <Replies id={id} data={r.replies} /> : null }
                              <button className={reply === r.databaseId ? 'active' : null} onClick={() => toggleReply(r.databaseId)} style={{width: '45px'}}>
                                { reply === r.databaseId ? <FontAwesomeIcon icon="times" size="lg" /> : <FontAwesomeIcon icon="reply" size="lg" /> }
                              </button>
                              { reply === r.databaseId ? <CommentForm id={id} parent={reply}/> : null }
                            </section>
                        </article>
                    </li>
                ))                                
            }   
        </ol>
    );
}